import Http from 'vue-resource/src/http'
import cable from '../../../../admin/cable'

export function _debounce(fn, delay) {
  let timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    // TODO: fix this two lines
    let args = arguments // eslint-disable-line
    let that = this // eslint-disable-line
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

export default {
  namespaced: true,
  state: {
    activeClientId: null,
    sidebar_sources: null,
    sidebar_styles: null,
    messages: null,
    consultations: null,
    collapsed: [],
    callbacks: [],
    debounce: null
  },
  getters: {
    sources: (state, getters) => {
      return state.sidebar_sources
    },
    styles: (state, getters) => {
      return state.sidebar_styles
    },
    messages: (state, getters) => {
      return state.messages
    },
    consultations: (state, getters) => {
      return state.consultations
    },
    collapsed: (state, getters) => {
      return state.collapsed
    }
  },
  actions: {
    start({state, commit}) {
      const self = this
      cable.subscriptions.create({channel: 'SidebarChannel'}, {
        received: (_) => {
          self.dispatch('admin/sidebar/update')
        }
      })

      const f = function () {
        self.dispatch('admin/sidebar/_update')
      }
      state.debounce = _debounce(f, 1500)
    },
    update({state, commit}) {
      state.debounce.call()
    },
    _update({state, commit}) {
      Http.get(`/admin/b/sidebar?client_id=${state.activeClientId}`).then((responce) => {
        // Do nothing if it redirects to login page
        if (typeof responce.body === 'object' && responce.body !== null) {
          state.sidebar_sources = responce.body.admin_sidebar_source
          state.sidebar_styles = responce.body.admin_sidebar_style
          state.messages = responce.body.messages
          state.consultations = responce.body.consultations

          state.callbacks.forEach((callback) => {
            callback.call()
          })
        }
      })
    },
    updateActiveClient({state, commit}, clientId) {
      state.messages = null
      state.consultations = null
      if (state.activeClientId != clientId && clientId != undefined) {
        state.activeClientId = clientId
        this.dispatch('admin/sidebar/update')
      }
    },
    registerCallback({state}, callback) {
      state.callbacks.push(callback)
      if (state.sidebar_sources) {
        callback.call()
      } else {
        this.dispatch('admin/sidebar/update')
      }
    },
    expand({state}, id) {
      const idx = state.collapsed.indexOf(id)
      state.collapsed.splice(idx, 1)
    },
    collapse({state}, id) {
      state.collapsed.push(id)
    }
  }
}
